// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5z-5";
export var imageContainer = "_5z-4";
export var metricsGrid = "_5z-2";
export var productDetailContainer = "_5z-1";
export var productListContainer = "_5z-0";
export var subscriberTableContainer = "_5z-3";